var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('b-modal',{staticClass:"onboarding-modal-wrapper",attrs:{"active":_vm.isOnboardingModalActive,"has-modal-card":"","trap-focus":"","destroy-on-hide":false,"aria-role":"dialog","aria-modal":""},on:{"update:active":function($event){_vm.isOnboardingModalActive=$event}}},[_c('Onboarding')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }